import React from 'react'
import { DateRangePickerSeeker } from '@ui-seeker/core'
import { groupedExportsDateRange, isLoadingTable } from 'Pages/Admin/GroupedExports/@signals'
import { batch } from '@preact/signals-react'
import { DATE_PRESETS } from '@constants'


export default function DateRangeFilter() {


	return <DateRangePickerSeeker
		label="Chose a date range"
		value={groupedExportsDateRange.value}
		onChange={e => batch(() => {
			isLoadingTable.value = true
			groupedExportsDateRange.value = e
		})}
		ranges={DATE_PRESETS}
	/>
}